import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DropdownModel} from '@shared/components/dropdown-button/model/dropdown.model';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent  implements OnInit {
    @Input() tabindex: number;
    @Input() isInfoTitleLast: boolean;
    @Input() cardPadding: '32' | 'top-200';
    @Input() cardInfo: boolean;
    @Input() cardInfoTitle: string;
    @Input() cardInfoTitleIcon: string;
    @Input() cardMainTitle: string;
    @Input() cardParagraph: string;
    @Input() disabled: boolean;
    @Input() selected: boolean;
    @Input() ariaLabel: string;
    @Input() showDropdownActions = true;
    @Input() menuItems: DropdownModel[] = [];
    @Input() triggerData: [{ triggerBtnIcon: string; triggerBtnClasses: string; triggerBtnIconSize: string; triggerBtnAriaLabel: any; triggerBtnIconColor: string }];
    @Output() cardClickEvent = new EventEmitter<void>();
    @Output() buttonEvent = new EventEmitter<void>();
    @Output() openMenuEvent: EventEmitter<void> = new EventEmitter<void>();
    readonly TAG_ICON = 'mat-icon';

    ngOnInit(): void {
    }


    onKeyUp(event): void {
        if (event.key === 'Enter' || event.code === 'Space') {
            this.cardClickEvent.emit();
        }
    }

    onElementClick(event): void {
        if (!this.disabled) {
            const clickedElement = event.target;
            if (clickedElement.matches(this.TAG_ICON)) {
                this.openMenu();
            } else {
                this.cardClickEvent.emit();
            }
        }

    }

    openMenu(): void {
        this.openMenuEvent.emit();
    }

    buttonMenuAction(event): void {
        this.buttonEvent.emit(event);
    }
}


